// extracted by mini-css-extract-plugin
export default {"container":"_1_6sa","image":"_2vZfq","desktop":"_3YIaf","mobile":"_1hEhd","imageFit":"_2RuLA"};